import React, { useEffect, useState } from 'react';
import { AlertService, Alert } from '../services/AlertService';
import './AlertContainer.css';

export const AlertContainer: React.FC = () => {
  const [alerts, setAlerts] = useState<Alert[]>([]);

  useEffect(() => {
    const alertService = AlertService;
    
    // Subscribe to alerts
    const unsubscribe = alertService.addListener((newAlerts: Alert[]) => {
      setAlerts(newAlerts);
    });

    // Get initial alerts
    setAlerts(alertService.getAlerts());

    // Cleanup subscription on unmount
    return unsubscribe;
  }, []);

  const handleClose = (id: string) => {
    const alertService = AlertService;
    alertService.remove(id);
  };

  if (alerts.length === 0) {
    return null;
  }

  return (
    <div className="alert-container">
      {alerts.map((alert) => (
        <div
          key={alert.id}
          className={`alert alert-${alert.type}`}
        >
          <div className="alert-content">
            <span className="alert-message">{alert.message}</span>
            <button 
              className="alert-close"
              onClick={() => handleClose(alert.id)}
              aria-label="Close alert"
            >
              ×
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};